import { onlyLatinCharsDigitsSpecialSymbolsRule } from '../../utils/form.constants'
import { FormRule } from 'antd'

const accountNumberLengthRules = [
  {
    min: 3,
    message: 'Minimum 3 characters',
    validateTrigger: 'onSubmit',
  },
  {
    max: 35,
    message: 'Maximum 35 characters',
    validateTrigger: 'onSubmit',
  },
]

export const intermediaryAccountNumberRules = [
  onlyLatinCharsDigitsSpecialSymbolsRule,
  ...accountNumberLengthRules,
]
export const accountNumberRules = [
  onlyLatinCharsDigitsSpecialSymbolsRule,
  ...accountNumberLengthRules,
  {
    required: true,
    message: 'Please enter account number',
    validateTrigger: 'onSubmit',
  },
]

export const isBankAccountFieldOptional = (
  bankCountry?: string,
  bankAccountCurrency?: string
) => {
  return (
    bankCountry === 'HK' &&
    ['HKD', 'CNY', 'USD'].includes(bankAccountCurrency || '')
  )
}

export const abaRoutingNumberRules = (bankCountry?: string): FormRule[] =>
  bankCountry === 'US'
    ? [
        {
          pattern: /^\d+$/,
          message: 'The value must be a number',
          validateTrigger: 'onSubmit',
        },
        {
          len: 9,
          message: 'Number must be 9 digits long',
          validateTrigger: 'onSubmit',
        },
        {
          required: true,
          message: 'Please enter ABA routing number',
          validateTrigger: 'onSubmit',
        },
      ]
    : []

export const bankStateBranchNumberRules = (bankCountry?: string): FormRule[] =>
  bankCountry === 'AU'
    ? [
        {
          pattern: /^\d+$/,
          message: 'The value must be a number',
          validateTrigger: 'onSubmit',
        },
        {
          len: 6,
          message: 'Number must be 6 digits long',
          validateTrigger: 'onSubmit',
        },
        {
          required: true,
          message: 'Please enter Bank State Branch number',
          validateTrigger: 'onSubmit',
        },
      ]
    : []

export const branchNumberRules = (
  bankCountry?: string,
  bankAccountCurrency?: string
): FormRule[] =>
  bankCountry !== 'AU' &&
  bankCountry !== 'US' &&
  !isBankAccountFieldOptional(bankCountry, bankAccountCurrency) &&
  !isIbanRequiredByCountryAndCurrency(bankCountry, bankAccountCurrency)
    ? [
        {
          pattern: /^\d+$/,
          message: 'The value must be a number',
          validateTrigger: 'onSubmit',
        },
        {
          min: 3,
          max: 8,
          message: 'Number must be 3 to 8 digits long',
          validateTrigger: 'onSubmit',
        },
        {
          required: true,
          message: 'Please enter Branch number',
          validateTrigger: 'onSubmit',
        },
      ]
    : []

const countriesWhereIbanIsRequired = [
  'AT',
  'BE',
  'BG',
  'HR',
  'CY',
  'CZ',
  'DK',
  'EE',
  'FI',
  'FR',
  'DE',
  'GR',
  'HU',
  'IS',
  'IE',
  'IT',
  'LV',
  'LT',
  'LU',
  'MT',
  'NL',
  'NO',
  'PL',
  'PT',
  'RO',
  'SK',
  'SI',
  'ES',
  'SE',
  'LI',
  'CH',
  'GB',
  'BA',
  'MK',
  'RS',
  'XK',
  'AL',
  'AD',
  'SM',
  'VA',
  'MC',
  'GI',
  'SA',
  'TN',
  'TR',
  'LB',
  'QA',
  'JO',
  'BH',
  'AE',
  'IL',
  'PK',
  'MU',
  'KZ',
]

export const isIbanRequiredByCountryAndCurrency = (
  bankCountry?: string,
  bankAccountCurrency?: string
) => {
  if (!bankCountry) return false
  if (!bankAccountCurrency) return false
  return countriesWhereIbanIsRequired.includes(bankCountry)
}

export const ibanRules = (
  bankCountry?: string,
  bankAccountCurrency?: string
): FormRule[] =>
  isIbanRequiredByCountryAndCurrency(bankCountry, bankAccountCurrency)
    ? [
        {
          pattern: /^[A-Za-z0-9]+$/,
          message: 'IBAN must contain only letters and numbers',
          validateTrigger: 'onSubmit',
        },
        {
          max: 34,
          message: 'IBAN cannot exceed 34 characters',
          validateTrigger: 'onSubmit',
        },
        {
          required: true,
          message: 'Please enter IBAN',
          validateTrigger: 'onSubmit',
        },
      ]
    : []
